export default __webpack_public_path__ + "static/6648-3ee83b27d21dab8d16ef4d400d545a66.jpg";